<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Page Visit History</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a routerLink="/home" (click)="SetInactive()">Home</a></li>
            <li class="breadcrumb-item active">Page Visit History</li>
          </ol>
        </div>
      </div>
    </div><!-- /.container-fluid -->
  </section>

  <!-- Main content -->
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
                <span class="info-box-icon bg-info"><i class="far fa-eye"></i></span>
  
                <div class="info-box-content">
                    <span class="info-box-text">Total Visit</span>
                    <span class="info-box-number">{{TotalVisit}}</span>
                </div>
                <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
        </div>
        <!-- /.col -->
        <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
                <span class="info-box-icon bg-success"><i class="far fa-file-alt"></i></span>
  
                <div class="info-box-content">
                    <span class="info-box-text">Highest Visited Page</span>
                    <span class="info-box-number">{{HighestVisitedPage}}</span>
                </div>
                <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
        </div>
        <!-- /.col -->
        <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
                <span class="info-box-icon bg-warning"><i class="far fa-user"></i></span>
  
                <div class="info-box-content">
                    <span class="info-box-text">Highest Visited By</span>
                    <span class="info-box-number">{{HighestVisitedBy}}</span>
                </div>
                <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
        </div>
        <!-- /.col -->
        <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
                <span class="info-box-icon bg-danger"><i class="fas fa-chart-line"></i></span>
  
                <div class="info-box-content">
                    <span class="info-box-text">Today's Total Visit</span>
                    <span class="info-box-number">{{TodayTotalVisit}}</span>
                </div>
                <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
        </div>
        <!-- /.col -->
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card card-primary card-outline">
            <div class="card-header">
              <h3 class="card-title">
                <i class="fas fa-chart-bar"></i>
                Page Visit History
              </h3>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
              <table #dataTable class="table table-bordered table-striped" style="width: 100%;">
              </table>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
  </section>
  <!-- /.content -->
</div>